import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';



const serverAddress = environment.endPoint;

@Injectable()
export class DomainInterceptor implements HttpInterceptor {
  constructor(private localStorage: LocalStorageService) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isGeneralAPI = request.url.startsWith('api');

    if (isGeneralAPI && !request.url.startsWith('api/login') && !request.url.startsWith('api/logout')) {
      this.localStorage.store('sessionActiveTime', Date.now());
    }
    if (isGeneralAPI || request.url.startsWith('oauth/')) {
      const token = this.localStorage.retrieve('token');
      let authHeaders = request.headers;

      if (isGeneralAPI && !authHeaders.get('Authorization') && token?.accessToken) {
        authHeaders = new HttpHeaders({
          'Authorization': `Bearer ${token.accessToken}`
        });
        request.headers.keys().forEach((key): void => {
          authHeaders = authHeaders.append(key, request.headers.get(key));
        });
      }
      request = new HttpRequest(
        request.method as any,
        `${serverAddress}/${request.url}`,
        request.body,
        {
          context: request.context,
          headers: authHeaders,
          params: request.params,
          reportProgress: request.reportProgress,
          responseType: request.responseType,
          withCredentials: isGeneralAPI
        }
      );
    }
    return next.handle(request);
  }
}
